// So far navbar.jsx was pretty well refracted here.
// Displayed on all pages.

// maybe in the future we can make it stay hidden and show upon hover of a small button or upon scrolling up
//edits

//testing to fix dark mode

import { useState } from "react";
import { Link } from "react-router-dom";
import NavbarLogo from "./NavbarLogo";
import NavbarLinks from "./NavbarLinks";
import styles from "./navbarrefracted.module.css";

function NavbarRefracted() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav
      className={`${styles.navbar} fixed top-0 left-0 z-50 w-full bg-pendle-500 bg-opacity-50 border-gray-200 backdrop-blur-md`}
    >
      <div className="flex flex-wrap items-center justify-between p-4 mx-auto max-2w-screen-2xl">
        <Link
          to="/"
          className="flex items-center space-x-3 rtl:space-x-reverse"
        >
          <NavbarLogo />
        </Link>
        <button
          data-collapse-toggle="navbar-default"
          type="button"
          className={`hamburger-menu inline-flex items-center justify-center w-10 h-10 p-2 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200`}
          aria-controls="navbar-default"
          aria-expanded="false"
          onClick={toggleMobileMenu}
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
        <div
          className={`${isMobileMenuOpen ? "block" : "hidden"} w-full md:block md:w-auto`}
          id="navbar-default"
        >
          <NavbarLinks />
        </div>
      </div>
    </nav>
  );
}

export default NavbarRefracted;
